"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSnackbar = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const useSnackbar = () => {
  const {
    open,
    onOpen,
    onClose
  } = (0, _presentationHooks.useDisclose)();
  const [message, setMessage] = (0, _react.useState)('');
  const timeoutRef = (0, _react.useRef)(null);
  const openSnackbar = (0, _react.useCallback)(requestedMessage => {
    setMessage(requestedMessage);
    onOpen();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      onClose();
      setMessage('');
    }, 3000);
  }, [onClose, onOpen]);
  return {
    openSnackbar,
    snackbar: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Snackbar, {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: open,
      message: message
    })
  };
};
exports.useSnackbar = useSnackbar;
//# sourceMappingURL=useSnackbar.js.map